/**
 * @generated SignedSource<<b7431df5b08ac34288ad943816cf9ddf>>
 * @relayHash 74b7ab26dae7800ca9d0a2256dba2ccb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a009fd960ee41e0f56f56a26b9f166dd4f589bcc8af1f2dfd6425f0e5976ffce

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessListQuery } from './src_jiraBusinessListQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a009fd960ee41e0f56f56a26b9f166dd4f589bcc8af1f2dfd6425f0e5976ffce",
    "metadata": {},
    "name": "src_jiraBusinessListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
